import wx from 'weixin-js-sdk'
import { getJsAPI } from '@/apis/weixin'
export default {
    //获取坐标
    getLocation(str = '') {
        return new Promise((resolve) => {
            let params = {}
            // if (str) {
            //     params = {
            //         url: window.location.origin+'/gzh-test/storevisitdata'
            //     }
            // } else {
            //     params = {
            //         url: window.location.href
            //     }
            // }
            params = {
                url: window.location.href
            }
            console.log(params)
            getJsAPI(params).then((res) => {
                let data = res.data
                wx.config({
                    debug: false, // 开启调试模式
                    appId: data.appId, // 必填，公众号的唯一标识
                    timestamp: data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.nonceStr, // 必填，生成签名的随机串
                    signature: data.signature, // 必填，签名，见附录1
                    jsApiList: ['checkJsApi', 'getLocation', 'openLocation'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
                });
                wx.ready(function () {
                    wx.getLocation({
                        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                        success: (res) => {
                            resolve(res)
                        },
                        cancel: () => {
                            resolve(res)
                        },
                        fail: (res) => {
                            resolve(res)
                        },
                    })
                });
                wx.error(function (res) {
                    console.log('jssdk验证失败', res)
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                });
            })
        })
    },
    openLocation(info) {
        let params = {
            url: window.location.href
        }
        getJsAPI(params).then((res) => {
            let data = res.data
            wx.config({
                debug: false, // 开启调试模式
                appId: data.appId, // 必填，公众号的唯一标识
                timestamp: data.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.nonceStr, // 必填，生成签名的随机串
                signature: data.signature, // 必填，签名，见附录1
                jsApiList: ['checkJsApi', 'getLocation', 'openLocation'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
            });
            wx.ready(function () {
                wx.openLocation({
                    latitude: parseFloat(info.storeLatitude), // 纬度，浮点数，范围为90 ~ -90
                    longitude: parseFloat(info.storeLongitude), // 经度，浮点数，范围为180 ~ -180。
                    name: info.storeName, // 位置名
                    address: info.storeAddress, // 地址详情说明
                    scale: 10, // 地图缩放级别,整型值,范围从1~28。默认为最大
                })
            });
            wx.error(function (res) {
                console.log('jssdk验证失败', res)
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            });
        })

    }
}
